module.exports = __webpack_public_path__ + "img/img8.f0ce63f9.svg";